/* ODAVIA Mengenrabatt-Staffel + Mengen-Steller.
   Die sichtbare Mengen-Eingabe (data-odavia-qty-display) spiegelt das versteckte
   Dawn-Mengenfeld (name="quantity", per form-Attribut dem Produktformular zugeordnet).
   Delegierte Events: funktioniert auch, wenn Dawn Teile der Sektion neu rendert. */
(function(){
  if (window.__odaviaQtyTiers) return;
  window.__odaviaQtyTiers = true;

  function toInt(v){ var n = parseInt(v, 10); return isNaN(n) ? null : n; }
  function rootOf(el){ return el && el.closest ? el.closest('[data-odavia-qty-tiers]') : null; }
  function scopeOf(root){ return (root && root.closest('product-info')) || document; }

  function findQtyInput(root){
    var scope = scopeOf(root);
    var input = scope.querySelector('quantity-input input[name="quantity"], .product-form__quantity input[name="quantity"]');
    if (input) return input;
    // Fallback: kein Mengen-Block vorhanden -> verstecktes Feld direkt im Produktformular anlegen
    var form = scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('product-form form');
    if (!form) return null;
    input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      form.appendChild(input);
    }
    return input;
  }
  function bounds(input){
    var min = input ? toInt(input.getAttribute('min')) : null;
    var max = input ? toInt(input.getAttribute('max')) : null;
    if (min === null || min < 1) min = 1;
    return { min: min, max: max };
  }
  function clamp(n, b){
    if (n === null || n < b.min) n = b.min;
    if (b.max !== null && b.max >= b.min && n > b.max) n = b.max;
    return n;
  }
  function activateTiers(root, qty){
    var items = root.querySelectorAll('[data-tier]');
    var active = null;
    items.forEach(function(el){
      var min = toInt(el.getAttribute('data-tier'));
      if (min !== null && qty >= min) active = el;
    });
    items.forEach(function(el){
      el.removeAttribute('data-active');
      el.setAttribute('aria-pressed', 'false');
    });
    if (active) {
      active.setAttribute('data-active', 'true');
      active.setAttribute('aria-pressed', 'true');
    }
  }
  function display(root){ return root.querySelector('[data-odavia-qty-display]'); }

  // Anzeige (Eingabefeld + aktive Stufe) aus dem versteckten Feld übernehmen
  // (nur bei Start und externen Resets durch Dawn, nicht während der Eingabe)
  function syncFromHidden(root){
    var input = findQtyInput(root);
    var b = bounds(input);
    var qty = clamp(input ? toInt(input.value) : null, b);
    var d = display(root);
    if (d) d.value = qty;
    if (d) d.setAttribute('min', b.min);
    activateTiers(root, qty);
    return qty;
  }

  // Menge setzen: sichtbares Feld, verstecktes Feld und aktive Stufe gleichziehen
  function setQty(root, qty, opts){
    opts = opts || {};
    var input = findQtyInput(root);
    var b = bounds(input);
    qty = clamp(qty, b);
    if (input && String(input.value) !== String(qty)) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var d = display(root);
    if (d && opts.writeDisplay !== false) d.value = qty;
    activateTiers(root, qty);
    return qty;
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    var root = rootOf(t);
    if (!root) return;
    var tier = t.closest('[data-tier]');
    var minus = t.closest('[data-odavia-qty-minus]');
    var plus = t.closest('[data-odavia-qty-plus]');
    if (!tier && !minus && !plus) return;
    var d = display(root);
    var current = toInt(d && d.value);
    if (current === null) current = syncFromHidden(root);
    if (tier) setQty(root, toInt(tier.getAttribute('data-tier')));
    else if (minus) setQty(root, current - 1);
    else setQty(root, current + 1);
  });

  // Tippen: gültige Zahl sofort übernehmen, leeres Feld erst beim Verlassen korrigieren
  document.addEventListener('input', function(e){
    var d = e.target;
    if (!d || !d.matches || !d.matches('[data-odavia-qty-display]')) return;
    var root = rootOf(d);
    if (!root) return;
    var n = toInt(d.value);
    setQty(root, n, { writeDisplay: n !== null && n >= 1 && String(n) !== d.value });
  });
  document.addEventListener('change', function(e){
    var d = e.target;
    if (!d || !d.matches || !d.matches('[data-odavia-qty-display]')) return;
    var root = rootOf(d);
    if (!root) return;
    setQty(root, toInt(d.value));
  });
  // Enter im Mengenfeld soll kein Formular absenden
  document.addEventListener('keydown', function(e){
    var d = e.target;
    if (e.key === 'Enter' && d && d.matches && d.matches('[data-odavia-qty-display]')) {
      e.preventDefault();
      d.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function syncAll(){
    document.querySelectorAll('[data-odavia-qty-tiers]').forEach(syncFromHidden);
  }
  function init(){
    syncAll();
    // Dawn setzt die Menge nach Variantenwechsel / Warenkorb-Update zurück -> Anzeige nachziehen
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, function(){ setTimeout(syncAll, 0); });
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function(){ setTimeout(syncAll, 0); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
